import { ColumnsType } from 'antd/lib/table'
import { useCallback } from 'react'
import { CIMSTableProps } from '../../types'
import { HelpMessage } from '../../../../utils/constants'
import HelpIcon from '../../../HelpIcon'
import { CheckSquareFilled } from '@ant-design/icons'
import CIMSTableCell from '../components/CIMSTableCell'
import { Tooltip, Typography } from 'antd'
import { useLocation } from 'react-router-dom'
import { ActivityItem } from '../types/actions/row'
import { dateFormatter } from '../../../../utils/dateFormatter'

export function useActiveColumnFn<T extends object>(
  actions: CIMSTableProps<T, any>['actions'] | undefined
) {
  const queryParams = new URLSearchParams(useLocation().search)
  const inactiveQueryParam = queryParams.get('inactive')
  const inactiveParam =
    inactiveQueryParam === 'inactive'
      ? (inactiveQueryParam as ActivityItem)
      : undefined

  return useCallback<(columns: ColumnsType<T>) => ColumnsType<T>>(
    (columns) => {
      if (!actions?.row?.restore) return columns
      const { default: d3fault, metadata } = actions.row.restore
      columns.splice(columns.length - 1, 0, {
        title: <HelpIcon text={HelpMessage.CIMSTable.Active}>Active</HelpIcon>,
        width: 120,
        align: 'center',
        key: 'active',
        defaultFilteredValue: inactiveParam
          ? [inactiveParam]
          : d3fault
          ? [d3fault]
          : undefined,
        filters: [
          { text: 'Active', value: 'active' },
          { text: 'Inactive', value: 'inactive' },
        ],
        filterIcon: <CheckSquareFilled />,
        onFilter: (value, record) =>
          metadata(record).removed ? value === 'inactive' : value === 'active',
        render: (record) => {
          const { removed, removedBy, removedDate } = metadata(record)
          const titles = [`Removed by ${removedBy}`]
          if (removedDate) titles.push(dateFormatter.shortDatetime(removedDate))
          return (
            <CIMSTableCell>
              <Tooltip title={!!removedBy ? titles.join(' ') : undefined}>
                <Typography.Text type={removed ? 'secondary' : 'success'}>
                  {removed ? 'Inactive' : 'Active'}
                </Typography.Text>
              </Tooltip>
            </CIMSTableCell>
          )
        },
      })
      return columns
    },
    [actions?.row?.restore, inactiveParam]
  )
}
